import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import ReportSummaryContext from '@/modules/reports/contexts/ReportSummaryContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';

function getText(offerName, affiliateName) {
    if (affiliateName) {
        return 'Source';
    }
    else if (offerName) {
        return 'Партнер';
    }
    else {
        return 'Оффер';
    }
}

const CellPrimary = () => {
    const reportSummaryContext = useContext(ReportSummaryContext);

    const { offerName, affiliateName } = useParams();

    return (
        <TableCellOrder className="primary"
                        orderName="primary" ordering={reportSummaryContext.ordering}
                        onClick={reportSummaryContext.handleClickOrder}
        >
            {getText(offerName, affiliateName)}
        </TableCellOrder>
    );
};

export default CellPrimary;
